/**
 * @fileoverview Workspace Workflows manager (MOR-696, renamed MOR-716)
 *
 * URL: /dashboard/workflows
 *
 * Firm-defined reusable workflows (a graph of template tasks with
 * subtasks, dependencies, statuses, labels, assignees and relative due-date
 * offsets). Applied to a job from inside the job, or auto-applied on job
 * creation by appointment type. Lives under the workspace Calendar section.
 *
 * - Convex: tasks.workflows.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { WorkflowsManager } from "@/components/settings/tasks/WorkflowsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/workflows/",
)({
  component: WorkflowsPage,
});

function WorkflowsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <WorkflowsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage workflows.
        </div>
      )}
    </div>
  );
}
